import React, { useRef, useState } from "react";
import { getAttachmentUrl } from "utils/formatChatData";
import Icon from "components/Icon";
import { createPortal } from "react-dom";
import { useDispatch } from "react-redux";
import { updateImageSlider } from "stores/chats/chats";
import { callReactNativeByParent } from "utils/utils";

type ChatImageSliderProps = {
  imageUrls: string[];
  chatId: string;
  messageId: string;
  messageType: string;
};

const ChatImageSlider: React.FC<ChatImageSliderProps> = ({
  imageUrls,
  chatId,
  messageId,
  messageType
}) => {
  const dispatch = useDispatch();
  const [allImages, setAllImages] = useState<string[]>(imageUrls);
  const [activeImage, setActiveImage] = useState<string | null>(null);
  const overlayRef = useRef(null);
  const containerRef = useRef(null);

  const changeActiveImage = (url: string) => {
    setActiveImage(url);
  };
  const closeModal = (eve: any) => {
    if (
      eve.target === overlayRef.current ||
      eve.target === containerRef.current
    ) {
      dispatch(
        updateImageSlider({
          isOpen: false
        })
      );
      const message = JSON.stringify({
        key: "SHOW_HEADER"
      });
      window.parent.postMessage(message, "*");
    }
  };
  const handleDownload = async () => {
    const imageUrl = getAttachmentUrl(activeImage);
    callReactNativeByParent({
      eventKey: "SAVE_TO_CAMERA_ROLL",
      data: { imageUrl: imageUrl }
    });
  };
  return createPortal(
    <div
      className={`slider ${activeImage ? "slider--active" : ""}`}
      onClick={closeModal}
      ref={overlayRef}
    >
      {!!activeImage && (
        <div className="slider__actions">
          <div>
            <button type="button" onClick={() => setActiveImage(null)}>
              {<Icon id="back" className="slider__icon" />}
            </button>
          </div>
          <div className="slider__cta-grp">
            <button type="button" onClick={handleDownload}>
              <Icon id="download" />
            </button>
          </div>
        </div>
      )}
      <div
        className={`slider__container ${
          allImages.length === 1 ? "slider__container--center" : ""
        }`}
        ref={containerRef}
      >
        {allImages.map((url, ind) => (
          <>
            <div
              className={
                activeImage === url
                  ? "slider__image-wrapper--active"
                  : "slider__image-wrapper"
              }
              key={ind}
              onClick={() => changeActiveImage(url)}
            >
              <img
                src={getAttachmentUrl(url)}
                alt="#"
                className={
                  activeImage === url ? "slider__img--active" : "slider__img"
                }
              />
            </div>
          </>
        ))}
      </div>
    </div>,
    document.body
  );
};

export default ChatImageSlider;
